import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { COMMON_TRANSLATION } from '@common/constants';
import { formatDate, formatTime } from '@common/utils';

import { BLANK_VALUE, GENETIC_COUNSELING_TRANSLATION } from '../../constants';
import { getTimeZoneString } from '../../utils';
import PatientProfileOverviewCard from '../shared/PatientProfileOverviewCard/PatientProfileOverviewCard';
import { MainInfo } from '../shared/PatientProfileOverviewCard/PatientProfileOverviewCard.types';
import { AppointmentCompletedCardProps } from './AppointmentCompletedCard.types';

const AppointmentCompletedCard: FC<AppointmentCompletedCardProps> = ({ appointmentInfo }) => {
  const { t } = useTranslation([GENETIC_COUNSELING_TRANSLATION, COMMON_TRANSLATION]);

  const { completionDate, timezone } = appointmentInfo;

  const getCompletionDate = (completionDate: string, timezone: string): string => {
    if (!completionDate || !timezone) {
      return BLANK_VALUE;
    }

    const date = formatDate(completionDate);
    const time = formatTime(completionDate, timezone);
    const tz = getTimeZoneString(completionDate, timezone);

    return t('date_time_human_readable', {
      date,
      ns: COMMON_TRANSLATION,
      time,
      tz,
    });
  };

  const appointmentInfoData: MainInfo[] = [
    {
      id: 'appt-completion-date',
      label: t('completed.counseling_status_card.completion_date'),
      value: getCompletionDate(completionDate, timezone),
    },
  ];

  return (
    <PatientProfileOverviewCard mainInfo={appointmentInfoData} title={t('completed.counseling_status_card.title')} />
  );
};

export default AppointmentCompletedCard;
